<template>
  <v-content>
    <Nav/>

    <!-- <div>category {{ $route.params.category }}</div> -->
    <blogposts
      :category="$route.params.category"
    />

    <Footer/>
  </v-content>
</template>

<script>
import Nav from '../components/global/Nav';
import Footer from '../components/global/Footer';
import blogposts from '../components/blogposts';


export default {
  name: 'blog',

  components: {
    Nav,
    Footer,
    blogposts,
  },

  props: {

  },

  data() {
    return {

    }
  },

  created: function() {

  },

  methods: {


  }
};
</script>